type CheckCircleOutlineIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const CheckCircleOutlineIcon = (props: CheckCircleOutlineIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10_11876)">
      <path
        d="M14.6667 7.38668V8.00001C14.6659 9.43763 14.2004 10.8365 13.3396 11.9879C12.4788 13.1393 11.2689 13.9817 9.89028 14.3893C8.51166 14.7969 7.03821 14.7479 5.68969 14.2497C4.34116 13.7515 3.18981 12.8307 2.40735 11.6247C1.62488 10.4187 1.25323 8.99205 1.34783 7.55755C1.44242 6.12306 1.99818 4.75756 2.93223 3.66473C3.86628 2.57189 5.12856 1.81027 6.53083 1.49344C7.9331 1.17662 9.40022 1.32157 10.7134 1.90668"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 2.66663L8 9.33996L6 7.33996"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_11876">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
